import React, { useState, useEffect } from "react";
import "./FormsTabContent.css";
import "../../../../App"
import InfoCard from "../../../ui/InfoCard/InfoCard";
import AddCard from "../../../ui/AddCard/AddCard";
import { FaFileAlt } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { formService } from "../../../../service";
import NewForm from "../../../form/NewForm/NewForm";
import EditForm from "../../../form/EditForm/EditForm";
import ConfirmDeleteModal from "../../../ui/ConfirmDeleteModal/ConfirmDeleteModal";
import { showSuccessToast, showErrorToast } from "../../../../utils/toastUtils";

const FormsTabContent = ({ onShowDetails }) => {
  const { studyId } = useParams();
  const [showNewForm, setShowNewForm] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [forms, setForms] = useState([]);
  const [formCounts, setFormCounts] = useState({});
  const [selectedFormToEdit, setSelectedFormToEdit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  const [showConfirm, setShowConfirm] = useState(false);
  const [selectedForm, setSelectedForm] = useState(null);

  const refreshForms = () => setRefreshTrigger((prev) => prev + 1);

  const handleAddClick = () => setShowNewForm(true);
  const handleCloseNewForm = (shouldRefresh = false) => {
    setShowNewForm(false);
    if (shouldRefresh) refreshForms();
  };

  const handleDeleteClick = (form) => {
    setSelectedForm(form);
    setShowConfirm(true);
  };

  const handleConfirmDelete = async () => {
    if (!selectedForm) return;
    try {
      const token = localStorage.getItem("token");
      await formService.delete(selectedForm.id, token);
      showSuccessToast(
        `Formulaire "${selectedForm.title}" supprimé avec succès !`
      );
      setShowConfirm(false);
      setSelectedForm(null);
      refreshForms();
    } catch (err) {
      console.error("Erreur lors de la suppression du formulaire :", err);
      showErrorToast("Erreur lors de la suppression du formulaire.");
    }
  };

  const handleEditClick = async (form) => {
    try {
      const res = await formService.countDocuments(form.id);
      const count = res.data.document_count;

      if (count > 0) {
        showErrorToast(
          "Impossible de modifier un formulaire contenant déjà des documents."
        );
        return;
      }

      const fullForm = await formService.getById(form.id);
      setSelectedFormToEdit(fullForm.data);
      setShowEditForm(true);
    } catch (err) {
      console.error("Erreur lors de la vérification du formulaire :", err);
      showErrorToast("Erreur lors de la vérification du formulaire.");
    }
  };

  const handleCloseEditForm = (shouldRefresh = false) => {
    setShowEditForm(false);
    setSelectedFormToEdit(null);
    if (shouldRefresh) refreshForms();
  };

  useEffect(() => {
    const fetchForms = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("token");
        const req = await formService.getSimple(studyId, token);
        const data = req.data || [];
        setForms(data);
        setError(null);

        const counts = {};
        for (const form of data) {
          try {
            const countRes = await formService.countDocuments(form.id);
            counts[form.id] = countRes.data.document_count;
          } catch (countErr) {
            console.error("Erreur lors du comptage des documents :", countErr);
            counts[form.id] = 0;
          }
        }
        setFormCounts(counts);
      } catch (err) {
        console.error("Erreur lors du chargement des formulaires :", err);
        setError("Impossible de charger les formulaires.");
        setForms([]);
      } finally {
        setLoading(false);
      }
    };
    fetchForms();
  }, [studyId, refreshTrigger]);

  return (
    <div className="overflow-y-auto px-0" style={{ height: "100%" }}>
      <div className="container-fluid">
        <div className="row g-3">
          <div className="col-12 col-sm-6 col-md-4 col-lg-3 add-form-card">
            <AddCard title="Nouveau formulaire" onADD={handleAddClick} />
          </div>

          {error && (
            <div className="alert alert-danger mt-3" role="alert">
              {error}
            </div>
          )}

          {!loading &&
            (forms.length > 0
              ? forms.map((form) => (
                  <div className="col-12 col-sm-6 col-md-4 col-lg-3" key={form.id}>
                    <InfoCard
                      title={form.title}
                      count={formCounts[form.id] ?? 0}
                      unit="Document"
                      Icon={FaFileAlt}
                      actionType="Voir les détails"
                      onClick={() => onShowDetails(form.id)}
                      onStatsClick={() => onShowDetails(form.id)}
                      options={[
                        {
                          label: "Modifier",
                          onClick: () => handleEditClick(form),
                        },
                        {
                          label: "Supprimer",
                          onClick: () => handleDeleteClick(form),
                        },
                      ]}
                    />
                  </div>
                ))
              : !error && (
                  <div className="col-12 text-center mt-3">
                    <p>Aucun formulaire disponible pour cette étude.</p>
                  </div>
                ))}
        </div>
      </div>

      <NewForm
        show={showNewForm}
        onClose={handleCloseNewForm}
        studyId={studyId}
      />

      {selectedFormToEdit && (
        <EditForm
          show={showEditForm}
          onClose={handleCloseEditForm}
          form={selectedFormToEdit}
        />
      )}

      <ConfirmDeleteModal
        show={showConfirm}
        onClose={() => setShowConfirm(false)}
        onConfirm={handleConfirmDelete}
        studyName={selectedForm?.title}
        type="le formulaire"
      />
    </div>
  );
};

export default FormsTabContent;
